import * as Yup from 'yup';

export const CreateMerSetaSdiValidationSchema = Yup.object().shape({
    beeCategoryId: Yup
        .object()
        .shape({
            id: Yup.number(),
            value: Yup.string(),
        })
        .required('BEE Category is required')
        .typeError('BEE Category is required'),
    type: Yup
        .object()
        .shape({
            id: Yup.number(),
            value: Yup.string(),
        })
        .required('Intervention Type is required')
        .typeError('Intervention Type is required'),

    title: Yup
        .object()
        .shape({
            id: Yup.number(),
            value: Yup.string(),
        })
        .required('Intervention Title is required')
        .typeError('Intervention Title is required'),
    courseName: Yup.string()
        .required('Course Name is required')
        .typeError('Course Name is required')
        .max(128, 'Course name must be less than 128 characters'),
    startDate: Yup.date()
        .required('Start Date is required')
        .typeError('Start Date is required'),
    endDate: Yup.date()
        .required('End Date is required')
        .typeError('End Date is required'),
    identifier: Yup.string()
        .required("Intervention identifier is required")
        .typeError("Intervention identifier is required")
        .max(50, "Intervention identifier must be less than 50 characters")
});

